/* eslint-disable react/prop-types */
import React from 'react';
import { Link } from 'gatsby';
import axios from 'axios';
import PropTypes from 'prop-types';
import './style.scss';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useAuthState } from 'react-firebase-hooks/auth';
import firebase from 'firebase';
import getCloudinary from '../../utils/getCloudinary';
import getIsWholesaleAccount from '../../utils/getIsWholesaleAccount';


const ProductItem = ({ product, className, scrollPosition }) => {
    // eslint-disable-next-line no-unused-vars
    const [authUser, userInitialising, userError] = typeof window !== 'undefined' ? useAuthState(firebase.auth()) : Array(3);
    const [isWholesaleAccount, setIsWholesaleAccount] = React.useState(false);

    React.useEffect(() => {
        getIsWholesaleAccount().then(wholesaleResult => setIsWholesaleAccount(wholesaleResult));
    }, [axios.interceptors.request.handlers.length]);


    return (
        <Link
            className={className || 'product-item column is-half-touch is-one-third-desktop'}
            to={
                product.variants.length > 1
                    ? `/${product.slug}?selected=${product.variant.name}`
                    : `/${product.slug}`
            }
        >
            <div className="card">
                {/* <div */}
                {/* className="pattern-background" */}
                {/* style={{ */}
                {/* backgroundImage: `url("${getCloudinary().url( */}
                {/* 'dashboard-uploads/white-diamond-background_mjkrp8', */}
                {/* { height: 500, crop: 'fit', fetch_format: 'auto' }, */}
                {/* )}")`, */}
                {/* }} */}
                {/* /> */}
                {/* <div className="pattern-background-gradient-overlay" /> */}

                <div className="foreground">
                    <LazyLoadImage
                        src={
                            getCloudinary().url(
                                product.variant.images.sort(
                                    (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
                                )[0].public_id,
                                { height: 292, crop: 'fit', fetch_format: 'auto' },
                            )
                        }
                        alt={product.name}
                        className="product-image"
                        height={292}
                        scrollPosition={scrollPosition}
                    />
                    <div className="card-content">
                        <div
                            className="product-item__variant-name title is-size-6-touch is-size-5-desktop has-text-centered"
                        >
                            {product.name}
                        </div>
                        <div
                            className="product-item__short-description subtitle is-size-6-touch is-size-5-desktop has-text-centered"
                        >
                            {product.variant.name}
                        </div>
                        <div className="title is-size-6-touch is-size-5-desktop has-text-centered">
                            {`£${isWholesaleAccount ? product.variant.wholesale_price : product.variant.price} (incl. VAT)`}
                        </div>
                    </div>
                </div>
            </div>
        </Link>
    );
};

ProductItem.defaultProps = {
    className: '',
    scrollPosition: 0,
};

ProductItem.propTypes = {
    className: PropTypes.string,
    scrollPosition: PropTypes.number,
    product: PropTypes.shape({
        name: PropTypes.string.isRequired,
        slug: PropTypes.string.isRequired,
        variant: PropTypes.shape({
            name: PropTypes.string,
            price: PropTypes.number,
            wholesale_price: PropTypes.number,
            images: PropTypes.arrayOf(
                PropTypes.shape({
                    url: PropTypes.string,
                }),
            ),
        }).isRequired,
    }).isRequired,
};

export default ProductItem;
